export const SESSIONKEY_SET = "SESSIONKEY_SET"
export const SESSIONKEY_CLEARED = "SESSIONKEY_CLEARED"
